import React from 'react';
import PropTypes from 'prop-types';
import { InfoWidget } from './InfoWidget';
import '../styles/hcHomepageStyles.css';

export const SkillContainer = (props) => {
    const handleSkillContainerClick = () => {
        return () => { props.handleSkillClick(props.trackerName); };
    };
    return (
        // Making this div into a button breaks InfoWidget in firefox due
        // to nested elements
        <div 
            className="skillContainerButton"
            onClick={handleSkillContainerClick(props)}
        >
            <div className="activityContainer" >
                <InfoWidget
                    id={props.id}
                    toolTipText={props.toolTipText}
                />
                <span id="homepageContainerName">{props.containerNames}</span>
                <img 
                    className="homepageContainerImage"
                    src={props.imgSrc} 
                    alt="Icon" />
                <div className="homepageActivityTracker"
                >
                    {`${props.activityAmounts.toString()}  ${props.activitiesTxt}`}
                </div>
            </div>
        </div>
    );
};

SkillContainer.propTypes = {
    id: PropTypes.number.isRequired,
    toolTipText: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
    activitiesTxt: PropTypes.string.isRequired,
    activityAmounts: PropTypes.number.isRequired,
    handleSkillClick: PropTypes.func.isRequired,
    containerNames: PropTypes.string.isRequired,
    trackerName: PropTypes.string.isRequired,
};

export default SkillContainer; 



// WEBPACK FOOTER //
// ./src/components/SkillContainer.jsx